import React, { FC, useMemo } from "react";
import { View, useDevice } from "@lookiero/aurora";
import { Pill, PillVariant } from "../../pill/Pill";
import { style as offeringsPillStyle } from "./OfferingsPill.style";

interface OfferingPillProps {
  readonly visible: boolean;
  readonly text: string;
  readonly isActive: boolean;
  readonly variant: PillVariant;
  readonly onPress: () => void;
}

const OfferingPill: FC<OfferingPillProps> = ({ visible, text, isActive, variant, onPress }) => {
  const { screen } = useDevice();

  const style = useMemo(() => offeringsPillStyle(), []);

  if (Boolean(visible) === false) {
    return null;
  }

  return (
    <View style={[style.separator, !screen.L ? style.fullWidth : null]}>
      <Pill active={isActive} style={screen.L ? undefined : style.pill} variant={variant} visible onPress={onPress}>
        {text}
      </Pill>
    </View>
  );
};

export { OfferingPill };
